import React from "react";
import { Box } from "@mui/material";

const AuthBackground = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        "&:before": {
          content: '""',
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at 50% 20%, rgba(56,189,248,0.10), transparent 60%)," +
            "radial-gradient(circle at 80% 80%, rgba(168,85,247,0.10), transparent 70%)",
          zIndex: -2,
        },
        "&:after": {
          content: '""',
          position: "absolute",
          inset: 0,
          backgroundImage:
            "linear-gradient(0deg, transparent 0, rgba(255,255,255,0.03) 1px)," +
            "linear-gradient(90deg, transparent 0, rgba(255,255,255,0.03) 1px)",
          backgroundSize: "80px 80px",
          opacity: 0.15,
          zIndex: -1,
        },
      }}
    >
      {children}
    </Box>
  );
};

export default AuthBackground;
